import styled from 'styled-components';

export const ContainerBotao = styled.button`
  background: none;
  outline: none;
`;

export const ContainerInformacoesAssinatura = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]}px;
`;
